/**
 * copy图标
 */
const CopyIcon = ({ width = 29, height = 28 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.99">
        <rect x="0.5" width="28" height="28" rx="14" fill="#F8F8F9" />
        <path
          d="M19.7 9.2C20.1243 9.2 20.5313 9.36857 20.8314 9.66863C21.1314 9.96869 21.3 10.3757 21.3 10.8V20.4C21.3 20.6101 21.2586 20.8182 21.1782 21.0123C21.0978 21.2064 20.9799 21.3828 20.8314 21.5314C20.6828 21.6799 20.5064 21.7978 20.3123 21.8782C20.1182 21.9586 19.9101 22 19.7 22H13.3C13.0899 22 12.8818 21.9586 12.6877 21.8782C12.4936 21.7978 12.3172 21.6799 12.1686 21.5314C12.0201 21.3828 11.9022 21.2064 11.8218 21.0123C11.7414 20.8182 11.7 20.6101 11.7 20.4V10.8C11.7 10.5899 11.7414 10.3818 11.8218 10.1877C11.9022 9.99359 12.0201 9.8172 12.1686 9.66863C12.3172 9.52006 12.4936 9.4022 12.6877 9.32179C12.8818 9.24138 13.0899 9.2 13.3 9.2H19.7ZM19.7 10.8H13.3V20.4H19.7V10.8ZM17.3 6C17.5122 6 17.7157 6.08429 17.8657 6.23431C18.0157 6.38434 18.1 6.58783 18.1 6.8L18.0992 7.6H10.1L10.0992 18.8H9.3C9.08783 18.8 8.88434 18.7157 8.73431 18.5657C8.58429 18.4157 8.5 18.2122 8.5 18V7.6C8.5 7.38988 8.54139 7.18183 8.62179 6.98771C8.7022 6.79359 8.82006 6.6172 8.96863 6.46863C9.1172 6.32006 9.29359 6.2022 9.48771 6.12179C9.68183 6.04139 9.88988 6 10.1 6H17.3Z"
          fill="#444446"
        />
      </g>
    </svg>
  )
}

export default CopyIcon
